import { css } from "@emotion/react";

// eslint-disable-next-line import/prefer-default-export
export const disabledCss = css`
  color: #616b74;
  cursor: "not-allowed";
`;
